import React from 'react'

import Spinner from '../Loader/Spinner'
import BarChartDisplay from './ColumnChartDisplay'

const ColumnChartAllergies = ({ data, chartName,renderType,locationName ,displayDate}) => {
  return data ? (
    <BarChartDisplay data={data} 
    chartName={chartName} renderType={renderType} 
    locationName={locationName}
    displayDate={displayDate}
    />
  ) : (
    <Spinner />
  )
}

export default ColumnChartAllergies
